<template>
  <div class="box vh-140">
    <div class="box-header">
      <h3 class="box-title"><i class="fa fa-th-large"></i> {{ project.name }}</h3>
      <div class="box-tools">
        <el-button class="pull-right" size="mini" @click="goBack()" plain><i class="fa fa-reply"></i> 返回</el-button>
      </div>
    </div>
    <div class="box-body">
      <!-- 工具栏-->
      <el-form size="small" :model="searchFm" inline>
        <el-form-item prop="userId" label="选择人员:">
          <el-select v-model="searchFm.userId" filterable placeholder="请选择人员">
            <el-option
              v-for="item in reportList"
              :key="item.userId"
              :label="item.trueName"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!project.customerId" prop="categoryId" label="选择行业:">
          <el-select v-model="searchFm.categoryId" collapse-tags placeholder="选择行业" style="width: 330px!important;">
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="postIds" label="选择岗位范围:">
          <el-select v-model="searchFm.postIds" clearable multiple collapse-tags placeholder="请选择岗位范围" style="width: 330px!important;">
            <el-option
              v-for="item in postList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button size="small" type="primary" @click="doSearch()" plain><i class="fa fa-search"></i> 搜索</el-button>
      </el-form>

      <el-table class="list-table" :data="userReports" ref="standardTable" border :stripe="true" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column prop="postName" label="岗位名称"></el-table-column>
        <el-table-column prop="name" label="模型名称"></el-table-column>
        <el-table-column label="岗位胜任力指数">
          <template slot-scope="scope">
            <el-progress :stroke-width="6" :percentage="scope.row.exponent"></el-progress>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="详情" width="150">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="toDetail(scope.row)"><i class="fa fa-eye" /> 查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title="人岗匹配"
      :visible.sync="dialog"
      width="40%"
      :before-close="() => { this.dialog = false }">
      <div id="postImg" :style="{width: '400px', height: '400px',margin:'0 auto'}"></div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { get } from "@api/evaluation/project";
import { findReporpList } from "@api/manage/company";
import { findUserPostMatch, getPostImage } from "@api/rep/model";
import { fetchAll as findCategory } from "@api/rep/category";
import { fetchByCategoryId as findPostByCategory, findByCustomer as findPostByCustomer } from "@api/rep/post";

export default {

  name: "",
  data() {
    return {
      project: {},
      postList: [],
      dialog: false,
      searchFm: {},
      reportList: [],
      categoryList: [],
      userReports: [],
      setting: {
        legend: { data: ["实际值", "标准值"] },
        radar: {
          name: {
            textStyle: {
              color: "#626066",
              borderRadius: 5,
              fontSize: 12,
              padding: [3, 5]
            }
          },
          splitNumber: 6,
          radius: 140,
          indicator: []
        },
        series: [
          {
            type: "radar",
            data: [{
              label: {
                normal: {
                  show: true,
                  formatter: function(params) {
                    return params.value;
                  }
                }
              },
              value: [],
              name: "实际值"
            },
              { value: [], name: "标准值" }
            ]
          }
        ]
      }
    };
  },
  watch:{
    'searchFm.categoryId':{
      handler(newType, oldType) {
        this.postList = []
        this.searchFm.postIds = ''
        this.findPost(newType)
      }
    }
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(["user", "company"]),
    projectId() {
      return this.$route.params.projectId;
    }
  },
  components: {},
  methods: {
    toDetail(data) {
      this.dialog = true;
      getPostImage(this.projectId, this.searchFm.userId, data.postId).then(resp => {
        let info = resp.data.result;
        this.setting.radar.indicator = info.degrees;
        this.setting.series[0].data[0].value = info.resScore;
        this.setting.series[0].data[1].value = info.standradList;
        let myChart = this.$echarts.init(document.getElementById("postImg"));
        myChart.setOption(this.setting);
      });
    },
    findCustomerPost(customerId) {
      findPostByCustomer(customerId).then(resp => {
        this.postList = resp.data.result;
      });
    },
    findCategory() {
      findCategory().then(resp => {
        this.categoryList = resp.data.result;
      });
    },
    findPost(id) {
      findPostByCategory(id).then(resp => {
        this.postList = resp.data.result;
      });
    },
    init() {
      get(this.projectId).then(resp => {
        this.project = resp.data.result;
      }).then(() => {
        this.findReportList();
        if (this.project.customerId != null && this.project.customerId != "") {
          this.findCustomerPost(this.project.customerId);
        } else {
          this.findCategory();
        }
      });
    },
    findReportList() {
      findReporpList(this.projectId).then(res => {
        this.reportList = res.data.result;
      });
    },
    doSearch() {
      if(!this.searchFm.userId){
        this.$message.error("请选择人员！")
        return false;
      }
      if(!this.searchFm.postIds){
        this.$message.error("请选择岗位！")
        return false;
      }
      let data = { projectId: this.projectId, userId: this.searchFm.userId, postIds: this.searchFm.postIds };
      findUserPostMatch(data).then(res => {
        this.userReports = res.data.result;
      });
    },
    goBack: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<style type="text/scss" lang="scss">
.dashboard-stat {
  border: none;
}

.dashboard-stat .visual {
  font-size: 58px;
  float: left;
  min-height: 50px;
}

.dashboard-stat .details {
  float: right;
  color: #ffffff;
}
</style>
